import { Row, Col } from 'react-materialize'

function Foot() {
    return (
        <Row className="Footer">
            <Col s={4} m={4} l={4}>
                <div className="center-icon">
                    <a href='mailto:reinlikely@gmail.com' target="_blank" rel="noreferrer"><img alt='reinlikely@gmail.com' className='icon' src='/email-icon.png'></img></a>
                </div>
            </Col>
            <Col s={4} m={4} l={4}>
                <div className="center-icon">
                    <a href="https://www.instagram.com/rein.likely/" target="_blank" rel="noreferrer"><img alt="@rein.likely" className="icon" src='/insta-logo.png'></img></a>
                </div>
            </Col>
            <Col s={4} m={4} l={4}>
                <div className="center-icon">
                    <a href="https://ReinLikely.bandcamp.com" target="_blank" rel="noreferrer"><img alt="ReinLikely.bandcamp.com" className="icon" src='/bandcamp-logo.png'></img></a>
                </div>
            </Col>
        </Row>
    );
}
export default Foot;